import AircraftModel from "../aircraft/AircraftModel";
import Attack from "./Attacks";

/**
 * FalseSqwakAttack
 * 
 * This attack will generate a fake emergency squawk code for the aircraft
 * 
 */
class FalseSqwakAttack extends Attack {
    /**
     * Creates an instance of FalseSqwakAttack.
     * 
     * @param {number} startTimestamp
     * @param {number} realSqwak 
     */
    constructor(startTimestamp, realSqwak) {
        super(startTimestamp);

        /**
         * The real squawk code of the aircraft
         * 
         * @property realSqwak
         * @type {number}
         */
        this.realSqwak = null;

        /**
         * Whether the aircraft has a fake squawk code
         * 
         * @property hasFakeSqwak
         * @type {boolean}
         */
        this.hasFakeSqwak = false;

        /**
         * Whether the aircraft has an emergency squawk code
         * 
         * @property hasEmergency
         * @type {boolean}
         */
        this.hasEmergency = false;

        this.init(realSqwak);
    }

    /**
     * Initialize the attack data for the aircraft
     * 
     * @for FalseSqwakAttack
     * @method initAttackData
     * @param aircraft {AircraftModel}
     */
    init(realSqwak) {
        super.init();
        this.realSqwak = realSqwak;
    }

    /**
     * Update the attack data for the aircraft
     * 
     * @for FalseSqwakAttack
     * @method updateAttackData
     * @param {aircaftModel} aircaft
     */
    update(aircaft) {
        if (!this.hasFakeSqwak) {
            this.hasFakeSqwak = true;
            aircaft.transponderCode = this._generateFakeEmergencySquawk();
        }
    }

    /**
     * @for FalseSqwakAttack
     * @method resetAttackData
     * @param {number} endTimestamp
     * @param {AircraftModel} aircraft
     */
    end(endTimestamp, aircraft) {
        super.end(endTimestamp);
        aircraft.transponderCode = this.realSqwak;
    }

    /**
     * Generate a fake emergency squawk code
     * 
     * @for FalseSqwakAttack
     * @method _generateFakeEmergencySquawk
     * @returns {string}
     * @private
     */
    _generateFakeEmergencySquawk() {
        let squawkCode;
        // Generate a random number between 0 and 1
        let randomChoice = Math.random();

        if (randomChoice < 0.2) {
        // 20% of the time, choose one of the codes "7500", "7600", "7700"
            let codes = ["7500", "7600", "7700"];
            squawkCode = codes[Math.floor(Math.random() * codes.length)];
        } else {
            // 80% of the time, generate a random code that includes at least one 8 or 9
            do {
                squawkCode = String(Math.floor(Math.random() * 10000)).padStart(4, '0');
            } while (!squawkCode.includes('8') && !squawkCode.includes('9'));
        }

        this.hasEmergency = true;

        return squawkCode;
    }

}

export default FalseSqwakAttack;